import React, { useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const { name, email, subject, message } = formData;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Valida los campos requeridos...

    if (name.trim() === "") {
      alert("Please enter your name.");
      return;
    }

    if (email.trim() === "") {
      alert("Please enter your email.");
      return;
    }

    if (subject.trim() === "") {
      alert("Please enter the subject.");
      return;
    }

    if (message.trim() === "") {
      alert("Please enter your message.");
      return;
    }

    setIsSending(true);

    try {
      // Envia el correo electrónico utilizando EmailJS
      await emailjs.sendForm(
        "service_knpd396",
        "template_ykeoo2c",
        e.target,
        "TzgSyFWDddnrBKKph"
      );

      setIsSending(false);
      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      }, 4000);
    } catch (error) {
      setIsSending(false);
      alert("Error al enviar el mensaje. Por favor, inténtalo nuevamente.");
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Contacto</h2>
          <p>
            ¡Estamos aquí para vos! Ponete en contacto con nosotros y permítenos
            brindarte la atención personalizada que necesitas.
          </p>
        </div>

        <div className="row gx-lg-0 gy-4">
          <div className="col-lg-4">
            <div className="info-container d-flex flex-column align-items-center justify-content-center">
              <div className="info-item d-flex">
                <i className="bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h4>Ubicación:</h4>
                  <p>Buenos Aires, Argentina.</p>
                </div>
              </div>

              <div className="info-item d-flex">
                <i className="bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h4>Email:</h4>
                  <p>tjmearplugs@hotmail.com</p>
                </div>
              </div>

              <div className="info-item d-flex">
                <i className="bi bi-phone flex-shrink-0"></i>
                <div>
                  <h4>Teléfono / WhatsApp:</h4>
                  <p>
                    <a href="https://wa.me/5491138054707" target="_blank" rel="noreferrer noopener" style={{ color: "inherit" }}>
                      +54 11 3805 4707
                    </a>
                  </p>
                </div>
              </div>

              <div className="info-item d-flex">
                <i className="bi bi-clock flex-shrink-0"></i>
                <div>
                  <h4>Horarios de atención:</h4>
                  <p>Lun - Vier: 9AM - 18PM</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <form onSubmit={handleSubmit} className="php-email-form">
              <div className="row">
                <div className="col-md-6 form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    id="name"
                    placeholder="Nombre y Apellido"
                    value={name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 form-group mt-3 mt-md-0">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Email"
                    value={email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-group mt-3">
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  id="subject"
                  placeholder="Asunto"
                  value={subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group mt-3">
                <textarea
                  className="form-control"
                  name="message"
                  rows="7"
                  placeholder="Mensaje"
                  value={message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <div className="my-3">
                {showSuccessMessage && (
                  <div className="alert alert-success" role="alert">
                    Su mensaje ha sido enviado. Pronto nos estaremos
                    comunicando.
                  </div>
                )}
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className={
                    isSending ? "sending" : showSuccessMessage ? "sent" : ""
                  }
                  disabled={isSending || showSuccessMessage}
                >
                  {isSending ? (
                    <>
                      <span className="sending-text">Enviando</span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : showSuccessMessage ? (
                    <div className="sent">
                      <span>Enviado</span>
                      <i className="bi bi-check2"></i>
                    </div>
                  ) : (
                    <span>Enviar mensaje</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="row mt-5 pt-4" data-aos="fade-up" data-aos-delay="100">
          <div className="col-12">
            <div className="map-container rounded overflow-hidden shadow-sm" style={{ height: "400px" }}>
              <iframe
                title="Mapa de ubicación"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105073.44366964347!2d-58.5033383!3d-34.6156624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcca3b4ef90cbd%3A0xa0b3812e88e88e87!2sBuenos%20Aires%2C%20CABA%2C%20Argentina!5e0!3m2!1ses!2sus!4v1690000000000!5m2!1ses!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
